class CartTimer extends HTMLElement {
  constructor() {
    super();
    this.CART_TIMER_KEY = 'shopify_cart_expiry_time_v2';
    this.CART_TIMER_DURATION = 30 * 60 * 1000; // 30 minutes
    this.interval = null;

    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style>
        #cart-timer-wrapper {
          display: none;
          font-size: 14px;
          text-align: center;
          background-color: #00AC87;
          border-style: dotted;
          border-radius: 8px;
          color: #fff;
          padding: 8px 10px;
          margin-bottom: 10px;
          max-width: 280px;
        }
        #cart-countdown {
          font-weight: bold;
        }
      </style>
      <div id="cart-timer-wrapper">
        Hurry! Your cart items will be lost in: <span id="cart-countdown">30:00</span>
      </div>
    `;

    this.wrapper = this.shadowRoot.getElementById('cart-timer-wrapper');
    this.countdown = this.shadowRoot.getElementById('cart-countdown');
  }

  connectedCallback() {
    this.resumeIfRunning();
  }

  start() {
    const existing = localStorage.getItem(this.CART_TIMER_KEY);
    if (existing && parseInt(existing) > Date.now()) return;

    const endTime = Date.now() + this.CART_TIMER_DURATION;
    localStorage.setItem(this.CART_TIMER_KEY, endTime.toString());

    this.show();
    this.run(endTime);
  }

  resumeIfRunning() {
    const expiry = parseInt(localStorage.getItem(this.CART_TIMER_KEY), 10);
    if (expiry && expiry > Date.now()) {
      this.show();
      this.run(expiry);
    } else {
      localStorage.removeItem(this.CART_TIMER_KEY);
    }
  }

  run(endTime) {
    clearInterval(this.interval);

    this.updateUI(endTime);
    this.interval = setInterval(() => {
      const now = Date.now();
      const remaining = endTime - now;

      if (remaining <= 0) {
        clearInterval(this.interval);
        localStorage.removeItem(this.CART_TIMER_KEY);
        this.clearCart();
        return;
      }

      this.updateUI(endTime);
    }, 1000);
  }

  updateUI(endTime) {
    const remaining = Math.max(endTime - Date.now(), 0);
    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    this.countdown.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  show() {
    this.wrapper.style.display = 'block';
  }

  clearCart() {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(() => location.reload());
  }

  unsetTimer() {
    localStorage.removeItem(this.CART_TIMER_KEY);
    console.log(false)
    this.wrapper.style.display = 'none';
  }
}

customElements.define('cart-timer', CartTimer);

// Usage:
// Enqueue: <script src="{{ 'cart-timer.js' | asset_url }}" defer="defer"></script>
// Add HTML: <cart-timer></cart-timer>
// Add to Start the timer: document.querySelector('cart-timer')?.start();
// Remove the timer: document.querySelector('cart-timer')?.unsetTimer();